import React from 'react';
import './testimonial.css';
import TestimonialCard from './TestimonialCard';

const testimonials = [
  {
    name: 'Sarah Johnson',
    photo: './person3.jpg',
    description: 'Niks Elite Cleaning left my house spotless! Punctual, professional, and detail-oriented. Highly recommended!',
    rating:5,
  },
  {
    name: 'James Lee',
    photo: './person1.png',
    description: 'Their deep cleaning service exceeded my expectations. Very courteous staff and efficient work.',
    rating:5,
  },
  {
    name: 'Priya Patel',
    photo: 'person4.jpeg',
    description: 'I booked them for a post-renovation cleanup. Amazing attention to detail. Will definitely book again.',
    rating:5,
  },
];
 
const Testimonail = () => {
  return (
    <section className="testimonials-section" id='testimonials'>
      <div className="section-title" >
        <h3 className="title" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">Testimonials</h3>
        <h2 className="sub-title" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">What Our Clients Say</h2>
      </div>
      <div className="testimonials-grid">
        {testimonials.map((testimonial, index) => (
            <TestimonialCard 
                key={index} 
                name={testimonial.name} 
                description={testimonial.description} 
                photo={testimonial.photo} 
                rating={testimonial.rating}
                dataAos="fade-up"
                dataAosDelay={index * 300}
            />
        ))}
      </div>
    </section>
  );
};

export default Testimonail;
